import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Heeft u een vraag over onze producten, documenten, het proces, of hebt u een verbeterpunt of een compliment?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Klik dan op \"Nieuwe vraag\" en vul de benodigde gegevens in. U krijgt binnen enkele dagen antwoord. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Let op! U kunt hieronder alleen vragen stellen met betrekking tot onze producten, documenten of het proces. ", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { useRouter } from 'vue-router'
import { questionStore } from '@/stores/question'
import { generalStore } from '@/stores/general'
import { onMounted } from 'vue'
import { IssueStatusColors } from '@/globalVariables'
import { IndexQuestion } from '@/types/service/question'
import { headerStore } from '@/stores/header'
import { authStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'Questions',
  setup(__props) {

const router = useRouter()

const columns = [
  {
    title: 'Ref. nr.',
    key: 'reference'
  },
  {
    title: 'Onderwerp',
    key: 'subject'
  },
  {
    title: 'Gemeld op',
    key: 'created_at'
  },
  {
    title: 'Bijgewerkt op',
    key: 'updated_at'
  },
  {
    title: 'Status',
    key: 'status'
  }
]

onMounted(() => {
  questionStore().getQuestions()
})

function onRowClick (question:IndexQuestion) {
  return {
    onClick: () => {
      router.push({ name: 'QuestionShow', params: { questionId: question.id.toString() } })
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      (_unref(generalStore)().appSettings?.notification?.pages.includes('Service'))
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            xs: {span: 24},
            sm: {span: 24},
            md: {span: 24},
            lg: {span: 18, offset: 3}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_alert, {
                type: "info",
                class: "global-notification mb-16",
                message: _unref(generalStore)().appSettings.notification.title,
                "show-icon": ""
              }, {
                description: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: _unref(generalStore)().appSettings.notification.description
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }, 8, ["message"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18, offset: 3}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Vragen",
            loading: _unref(questionStore)().loading
          }, _createSlots({
            default: _withCtx(() => [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _hoisted_3,
                      (_unref(headerStore)().buildingDelivered)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                            _createTextVNode(" Heeft u na de oplevering van uw woning een onvolkomenheid en wilt u een servicemelding doen?"),
                            _hoisted_5,
                            _createTextVNode(" Ga dan naar de pagina Service en Klik op ' + Nieuwe melding' en vul het formulier zo volledig mogelijk in."),
                            _hoisted_6,
                            _createTextVNode(" Als u direct toegang wilt tot de \"Service\" pagina, kunt u hier klikken: "),
                            _createVNode(_component_router_link, { to: "service" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Service Meldingen")
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        disabled: _unref(authStore)().restricted(),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'QuestionCreate' })))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Nieuwe vraag")
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      (_unref(generalStore)().desktop)
                        ? (_openBlock(), _createBlock(_component_a_table, {
                            key: 0,
                            columns: columns,
                            "data-source": _unref(questionStore)().questions,
                            pagination: false,
                            "custom-row": onRowClick,
                            "row-key": "id",
                            "row-class-name": "clickable-row"
                          }, {
                            bodyCell: _withCtx(({ column, record }) => [
                              (column.key === 'reference')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(record.id), 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (column.key === 'subject')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(record.title), 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (column.key === 'created_at')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(record.created_at ? new Date(record.created_at).toLocaleDateString('nl-NL') : '-'), 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (column.key === 'updated_at')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createTextVNode(_toDisplayString(record.updated_at ? new Date(record.updated_at).toLocaleDateString('nl-NL') : '-'), 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (column.key === 'status')
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 4,
                                    color: _unref(IssueStatusColors)[record.status.id]
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(record.status.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["data-source"]))
                        : (_openBlock(), _createBlock(_component_a_list, {
                            key: 1,
                            "data-source": _unref(questionStore)().questions,
                            "item-layout": "vertical",
                            pagination: false
                          }, {
                            renderItem: _withCtx(({ item }) => [
                              _createVNode(_component_a_list_item, {
                                style: { padding: '16px 0' },
                                onClick: ($event: any) => (_unref(router).push({ name: 'QuestionShow', params: { questionId: item.id.toString() } }))
                              }, {
                                actions: _withCtx(() => [
                                  _createVNode(_component_a_tag, {
                                    color: _unref(IssueStatusColors)[item.status.id]
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.status.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_list_item_meta, null, {
                                    title: _withCtx(() => [
                                      _createTextVNode("#" + _toDisplayString(item.id) + " - " + _toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createTextVNode(" Gemeld op: " + _toDisplayString(item.created_at ? new Date(item.created_at).toLocaleDateString('nl-NL') : '-'), 1),
                                  _hoisted_7,
                                  _createTextVNode(" Bijgewerkt op: " + _toDisplayString(item.updated_at ? new Date(item.updated_at).toLocaleDateString('nl-NL') : '-'), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 1
                          }, 8, ["data-source"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 2
          }, [
            (_unref(generalStore)().desktop)
              ? {
                  name: "extra",
                  fn: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Terug naar dashboard")
                      ]),
                      _: 1
                    })
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})